export var SaasEntityType;
(function (SaasEntityType) {
    SaasEntityType["SAAS_ENTITY_TYPE_USER"] = "USER";
    SaasEntityType["SAAS_ENTITY_TYPE_GROUP"] = "GROUP";
    SaasEntityType["SAAS_ENTITY_TYPE_SHARED_DRIVE"] = "SHARED_DRIVE";
    SaasEntityType["SAAS_ENTITY_TYPE_SHAREPOINT_SITE"] = "SHAREPOINT_SITE";
    SaasEntityType["SAAS_ENTITY_TYPE_TEAM"] = "TEAM";
})(SaasEntityType || (SaasEntityType = {}));
